import emptyReducer from './emptyReducer';

const toHeight = emptyReducer<string | null>(null).with({
  BodyMassIndex: (heightFt, heightIn, weightLb) => (heightFt ? `${heightFt}' ${heightIn ? heightIn : 0}"` : null),
});

export default toHeight;
